export default theme => ({
  topbar: {},
  drawerPaper: {
    width: "270px",
    height: "100%",
    backgroundColor: "#1c1c22", // Graphite sidebar background
  },
  sidebar: {
    width: "270px",
  },
  content: {
    minHeight: "100vh",
    backgroundColor: theme.palette.background.default,
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  },
  contentWrapper: {
    padding: 0,
  },
  contentShift: {
    marginLeft: "270px"
  }
});
